import { GetAuthToken } from '@domain/auth/AuthContext';
import { IAvatar } from '@domain/user/types';

import { returnJsonOrThrow, post } from './shared';

export const uploadAvatar = async (
  file: File,
  getAuthToken: GetAuthToken,
): Promise<{ image: IAvatar }> => {
  const data = new FormData();
  data.append('image', file);
  const response = await post('/me/avatars', getAuthToken, true, data);
  return returnJsonOrThrow<{ image: IAvatar }>(response);
};
